module.exports = __webpack_public_path__ + "fa7e074f7651195ba931fb2d9ddf9b99.svg";